/**
 * En-tête de table entraînement (match par équipes) :
 * « [avatar] ÉquipeA en attaque | [avatar] ÉquipeB en défense »
 */

import PlayerAvatar from './PlayerAvatar';
import { BACKEND_URL } from '../config';
import type { CompareReplayTeamSide } from '../utils/competitionReplay';

function teamAvatarUrl(team: CompareReplayTeamSide, size: number): string {
  const key = team.nom.trim() || `Équipe #${team.id}`;
  return `${BACKEND_URL}/api/avatars/team/${encodeURIComponent(key)}?size=${size * 2}`;
}

function TeamChip({ team, role }: { team: CompareReplayTeamSide; role: 'attaque' | 'défense' }) {
  const label = team.nom.trim() || `Équipe #${team.id}`;
  return (
    <span className="training-team-table-header-chip" title={`${label} en ${role}`}>
      <PlayerAvatar pseudo={label} size={18} photoUrl={teamAvatarUrl(team, 18)} />
      <span className="training-team-table-header-name">{label}</span>
      <span className="training-team-table-header-role">en {role}</span>
    </span>
  );
}

interface TrainingTeamTableHeaderProps {
  attackTeam: CompareReplayTeamSide;
  defenseTeam: CompareReplayTeamSide;
}

export default function TrainingTeamTableHeader({
  attackTeam,
  defenseTeam,
}: TrainingTeamTableHeaderProps) {
  return (
    <div className="replay-pane-header training-team-table-header">
      <div className="training-team-table-header-main">
        <TeamChip team={attackTeam} role="attaque" />
        <span className="training-team-table-header-sep" aria-hidden>|</span>
        <TeamChip team={defenseTeam} role="défense" />
      </div>
    </div>
  );
}
